const columns = [
  {
    title: "内容栏目",
    links: [
      { label: "焦点速览", href: "#spotlight" },
      { label: "深度解读", href: "#deep" },
      { label: "复盘拆解", href: "#timeline" },
      { label: "细节分析", href: "#insights" },
    ],
  },
  {
    title: "参与互动",
    links: [
      { label: "观点碰撞", href: "#opinions" },
      { label: "热议榜", href: "#trending" },
      { label: "社区讨论", href: "#opinions" },
      { label: "下载 App", href: "#download" },
    ],
  },
  {
    title: "关于看点",
    links: [
      { label: "复盘准则", href: "#timeline" },
      { label: "作者团队", href: "#deep" },
      { label: "内容纠错", href: "#opinions" },
      { label: "联系我们", href: "#download" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-900 text-background-200 px-4 md:px-8 pt-14 pb-8">
      <div className="max-w-shell mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-eye-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50 tracking-wide">
                黑料看点
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-400">
              黑料看点专注深度解读与复盘拆解，从蛛丝马迹到完整脉络，
              用多角度分析与观点碰撞，帮你看懂事件背后的逻辑与隐藏信息。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-rss-line"].map((icon) => (
                <a
                  key={icon}
                  href="#download"
                  aria-label="官方账号"
                  className="w-9 h-9 rounded-md bg-background-50/10 hover:bg-background-50/20 flex items-center justify-center text-background-100 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {columns.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-sm font-bold text-background-50">
                  <a href="#top" className="cursor-pointer hover:text-primary-300 transition-colors">
                    {col.title}
                  </a>
                </h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            © 2026 黑料看点 · 深度解读 / 复盘拆解 / 细节分析
          </p>
          <p className="text-xs text-background-500">
            站内内容均标注出处，观点仅代表作者本人
          </p>
        </div>
      </div>
    </footer>
  );
}